/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import RegistrationStep from '../../atoms/registration-step';
import styles from './registration-steps.module.scss';

const RegistrationSteps = ({
  steps,
  sport,
  className = '',
  info = steps?.sports_data[sport]?.note,
  imagePath = steps?.laptop_logo,
  link = '',
  context = '',
  tncText = '',
  isStorybook = false,
  isGamebox = false,
  hasTNCModal = false,
  gtmClass = '',
}) => (
  <div
    className={`${styles.stepsWrapper} ${styles[className]} ${styles[sport]} ${
      isGamebox && styles.stepsWrapperGamebox
    } `}
  >
    <RegistrationStep
      title={steps?.sports_data[sport]?.step_1_heading}
      imagePath={imagePath}
      color={sport}
      icon="hand"
      description={steps?.sports_data[sport]?.step_1_subheading}
      link={link}
      arrowPath={isStorybook ? './arrow-right.png' : '../../../../../images/arrow-right.png'}
      className={className}
      isGamebox={isGamebox}
      gtmClass={gtmClass}
    />
    <RegistrationStep
      title={steps?.sports_data[sport]?.step_2_heading}
      color={sport}
      icon="pencil"
      description={steps?.sports_data[sport]?.step_2_subheading}
      link={link}
      arrowPath={isStorybook ? './arrow-right.png' : '../../../../../images/arrow-right.png'}
      className={className}
      isGamebox={isGamebox}
      gtmClass={gtmClass}
    />
    <RegistrationStep
      title={steps?.sports_data[sport]?.step_3_heading}
      color={sport}
      icon={sport}
      description={steps?.sports_data[sport]?.step_3_subheading}
      link={link}
      info={info}
      arrowPath={isStorybook ? './arrow-right.png' : '../../../../../images/arrow-right.png'}
      // the third arrow must be shown only on love stream providers page
      className={className}
      hasTNCModal={hasTNCModal && context === 'provider-tabs'}
      tncText={tncText}
      provider={steps}
      isGamebox={isGamebox}
      gtmClass={gtmClass}
    />
  </div>
);

RegistrationSteps.propTypes = {
  steps: PropTypes.shape({
    laptop_logo: PropTypes.string,
    sports_data: PropTypes.shape({
      tennis: PropTypes.shape({}),
      soccer: PropTypes.shape({}),
      handball: PropTypes.shape({}),
    }),
  }),
  info: PropTypes.string,
  imagePath: PropTypes.string,
  sport: PropTypes.string,
  className: PropTypes.string,
  link: PropTypes.string,
  context: PropTypes.string,
  tncText: PropTypes.string,
  isStorybook: PropTypes.bool,
  isGamebox: PropTypes.bool,
  hasTNCModal: PropTypes.bool,
  gtmClass: PropTypes.string,
};

export default RegistrationSteps;
